import { getTurbohavaleBanks } from "@actions/withdraw";
import FormItem from "@components/formItem";
import CloseIcon from "@pages/casino/assets/icons/CloseIcon.jsx";
import {
	ItemWrapper,
	ModalItem,
	ModalItemsWrapper,
} from "@pages/casino/components/Dropdown/element";
import { ModalHeader } from "@pages/casino/components/Modal/elements.js";
import Modal from "@pages/casino/components/Modal/index.jsx";
import { CloseIconOverlay } from "@pages/casino/containers/SearchModal/elements";
import { MaskedInputLabel } from "@pages/profile-v2/pages/withdraw/baseItems";
import FloatingLabelButton from "@pages/profile-v2/pages/withdraw/FloatingLabelButton";
import React from "react";
import MaskInput from "react-maskinput";
import { Box, Content, ContentTitle, MaskedInput } from "../baseItems";
import Base from "./base";

export default class TrendHavale extends Base {
	constructor(props) {
		super(props);
		this.state = {
			...this.state,
			open: false,
			selectedItem: null,
			bankName: "",
			showAccountMask: false,
			accountNumber: "",
			accountNumberValue: "",
			canForward: false,
			banks: [],
		};
		this.accountInputRef = React.createRef();
	}

	componentDidMount() {
		super.componentDidMount();
		getTurbohavaleBanks().then((res) => {
			this.setState({ banks: res.data });
		});
		this.checkRequiredFields();
	}

	componentDidUpdate(prevProps, prevState) {
		if (
			prevState.accountNumber !== this.state.accountNumber ||
			prevState.selectedCurrency !== this.state.selectedCurrency ||
			prevState.bankName !== this.state.bankName
		) {
			this.checkRequiredFields();
		}
	}

	handleSelect = (item) => {
		this.setState({ bankName: item.label, open: false, selectedItem: item });
	};

	onEnterValue = (field, e) => {
		const value = e.target.value.replace(/_/g, "").trim();
		let cleanedValue = value;
		if (field === "accountNumber") {
			cleanedValue = value.replace(/^TR/g, "").trim();
		}
		this.setState(
			{
				[field]: field === "accountNumber" ? `TR${cleanedValue}` : cleanedValue,
				[`${field}Value`]: cleanedValue,
			},
			this.checkRequiredFields
		);
	};

	handleFocus = (field) => {
		this.setState({ [field]: true });
	};

	handleBlur = (field, e) => {
		const value = e.target.value.replace(/_/g, "").trim();
		let cleanedValue = value;
		if (field === "showAccountMask") {
			cleanedValue = value.replace(/^TR/g, "").trim();
		}
		const isEmptyOrMasked = cleanedValue === "";
		this.setState(
			(prevState) => ({
				[field]: false,
				[`${field.replace("show", "").toLowerCase()}Value`]: isEmptyOrMasked
					? ""
					: cleanedValue,
				[field.replace("show", "").toLowerCase()]: isEmptyOrMasked ? "" : cleanedValue,
			}),
			this.checkRequiredFields
		);
	};

	checkRequiredFields = () => {
		const { accountNumberValue, selectedCurrency, bankName } = this.state;
		if (accountNumberValue && selectedCurrency && bankName) {
			this.setState({ canForward: true });
		} else {
			this.setState({ canForward: false });
		}
	};

	preventFocus = (e) => {
		e.preventDefault();
		this.setState({ open: true });
	};

	getStep1(translate) {
		const {
			selectedCurrency,
			bankName,
			open,
			selectedItem,
			showAccountMask,
			accountNumberValue,
			accountNumber,
			banks,
		} = this.state;
		let bankOptions = [{ value: 0, label: translate("PLEASE_SELECT") }];

		if (banks && banks.length > 0) {
			banks.forEach((bank) => {
				if (bank.active === "1") {
					bankOptions.push({
						value: bank.id,
						label: bank.banka,
					});
				}
			});
		}

		let selectedBank = bankName ? bankOptions?.find((o) => o.value === bankName)?.value : 0;
		const filteredItems = bankOptions.filter((item) => item.value !== 0);

		return (
			<Content>
				<ContentTitle>{translate("Payment_Stake")}</ContentTitle>
				<FormItem onRegister={() => this.registerField({ name: "bankName" })}>
					<Box>
						<FloatingLabelButton
							label={translate("BANK_NAME")}
							name="bankName"
							type="text"
							onClick={this.preventFocus}
							value={bankName}
							onChange={(e) => this.setState({ bankName: e.target.value })}
						/>
					</Box>
				</FormItem>
				{bankName && bankName === "papara" && (
					<FormItem onRegister={() => this.registerField({ name: "accountNumber" })}>
						<Box>
							<MaskedInput>
								<MaskInput
									ref={this.accountInputRef}
									alwaysShowMask={window.IS_MARS ? true : false}
									onFocus={() => this.handleFocus("showAccountMask")}
									onBlur={(e) => this.handleBlur("showAccountMask", e)}
									value={showAccountMask ? accountNumber : accountNumberValue}
									mask="0000000000000000000000"
									maskChar={showAccountMask ? "_" : ""}
									size={20}
									onChange={(e) => this.onEnterValue("accountNumber", e)}
								/>
								<MaskedInputLabel
									isFocused={showAccountMask}
									hasValue={accountNumberValue}>
									{translate("ACCOUNT_NUMBER")}
								</MaskedInputLabel>
							</MaskedInput>
						</Box>
					</FormItem>
				)}
				{bankName && bankName !== "papara" && (
					<FormItem onRegister={() => this.registerField({ name: "accountNumber" })}>
						<Box>
							<MaskedInput>
								<MaskInput
									ref={this.accountInputRef}
									alwaysShowMask={window.IS_MARS ? true : false}
									onFocus={() => this.handleFocus("showAccountMask")}
									onBlur={(e) => this.handleBlur("showAccountMask", e)}
									value={showAccountMask ? accountNumber : accountNumberValue}
									mask="TR00 0000 0000 0000 0000 0000 00"
									maskChar={showAccountMask ? "_" : ""}
									size={30}
									onChange={(e) => this.onEnterValue("accountNumber", e)}
								/>
								<MaskedInputLabel
									isFocused={showAccountMask}
									hasValue={accountNumberValue}>
									{translate("IBAN")}
								</MaskedInputLabel>
							</MaskedInput>
						</Box>
					</FormItem>
				)}
				{this.getCurrencyField(translate)}
				{selectedCurrency &&
					selectedCurrency !== translate("PLEASE_SELECT") &&
					this.getStakeField()}
				{this.renderMinMax()}

				{/* Modal */}
				<Modal
					position={"top"}
					hasOverflow
					open={open}
					isPaymentPage
					onClose={() => this.setState({ open: false })}>
					<ModalItemsWrapper>
						<ModalHeader>{translate("Bank_Selection")}</ModalHeader>
						<ItemWrapper
							isPaymentPage
							className="item-wrapper">
							{filteredItems.map((item) => (
								<ModalItem
									key={item.value}
									isSelected={item.value === selectedItem?.value}
									onClick={() => this.handleSelect(item)}>
									{item.label}
								</ModalItem>
							))}
							<CloseIconOverlay />
							<CloseIcon
								className="modal-close-icon payment"
								onClick={() => {
									this.setState({ open: false });
								}}
							/>
						</ItemWrapper>
					</ModalItemsWrapper>
				</Modal>
			</Content>
		);
	}

	goForward(step) {
		const { stake, selectedCurrency } = this.state;
		const { selectedWithdraw } = this.props;

		if (!this.state.canForward) return;

		const currency = selectedWithdraw.currencies.find(
			(item) => item.currency === selectedCurrency
		);

		if (currency && stake < currency.withdraw.min) {
			this.props.showAlert({
				type: "error",
				msg: "STAKE_RANGE_WARNING_MIN",
				title: "ERROR",
			});
			return;
		}

		if (currency && stake > currency.withdraw.max) {
			this.props.showAlert({
				type: "error",
				msg: "STAKE_RANGE_WARNING_MAX",
				title: "ERROR",
			});
			return;
		}

		const newStep = step + 1;
		this.setState({ currentStep: newStep });
	}

	makeExternalPayment() {
		const { accountNumber, bankName, stake, selectedCurrency } = this.state;
		let withdrawData = {
			type: "TrendHavale",
			bank: bankName,
			account_number: accountNumber,
			amount: { value: Number(stake), currency: selectedCurrency },
		};
		this.props.onWithdraw(withdrawData, () => {
			this.onBackToWithdrawPage();
		});
	}

	render() {
		const { canForward } = this.state;
		return super.render();
	}
}
